import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import * as styles from './SecondaryNavMobile.module.less';

const SecondaryNavMobileSubHeader = ({
  activeTab,
  link,
  getKey,
  isOpen,
  onClick,
}) => {
  return (
    <div
      className={classNames(styles.subMenu__sideScroll, {
        [styles.subMenu__sideScrollOpen]: isOpen,
      })}
    >
      {link?.childItems.map(childItem => (
        <a
          className={classNames(styles.subMenu__sideScrollText, {
            [styles.subMenu__activeTab]: activeTab === getKey(childItem),
          })}
          href={`#${getKey(childItem)}`}
          id={`side_${getKey(childItem)}`}
          key={`sub-header-${getKey(childItem)}`}
          onClick={() => onClick(getKey(childItem))}
        >
          {childItem.text}
        </a>
      ))}
    </div>
  );
};

SecondaryNavMobileSubHeader.propTypes = {
  link: PropTypes.shape({
    path: PropTypes.string,
    name: PropTypes.string,
    childItems: PropTypes.arrayOf(PropTypes.object),
  }),
  activeTab: PropTypes.string,
  getKey: PropTypes.func.isRequired,
  isOpen: PropTypes.bool,
  onClick: PropTypes.func.isRequired,
};

SecondaryNavMobileSubHeader.defaultProps = {
  activeTab: '',
  isOpen: false,
  link: null,
};

export default SecondaryNavMobileSubHeader;
